import type { BlogArticle, BlogLang } from '../types/blog'

const BASE_URL = 'https://denticoclinic.co.uk'
const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png'

const htmlLang: Record<BlogLang, string> = {
  en: 'en',
  ua: 'uk',
  ru: 'ru',
  ro: 'ro',
}

/** Strips the `[anchor](/path)` inline-link syntax, leaving plain text. */
export function stripInlineLinks(text: string): string {
  return text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
}

export function getArticleUrl(slug: string, lang: BlogLang): string {
  return `${BASE_URL}/${lang}/blog/${slug}`
}

/** BlogPosting + FAQPage JSON-LD. FAQ entries mirror the visible FAQ exactly. */
export function buildBlogSchema(
  article: BlogArticle,
  lang: BlogLang,
): Record<string, unknown>[] {
  const url = getArticleUrl(article.slug, lang)
  const organization = {
    '@type': 'Organization',
    name: 'Dentico Clinic',
    url: BASE_URL,
    logo: { '@type': 'ImageObject', url: LOGO_URL },
  }
  const blogPosting = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: article.h1[lang],
    description: article.seoDescription[lang],
    image: [LOGO_URL],
    author: organization,
    publisher: organization,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    inLanguage: htmlLang[lang],
    url,
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
  }
  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: htmlLang[lang],
    mainEntity: article.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q[lang],
      acceptedAnswer: {
        '@type': 'Answer',
        text: stripInlineLinks(faq.a[lang]),
      },
    })),
  }
  return [blogPosting, faqPage]
}
